import styled from 'styled-components';
import { Typ30, Typ31 } from 'dc/Typ';
import SwiLab02 from 'dc/SwiLab02';
import TxtField07 from 'dc/TxtField07';
import TxtField03 from 'dc/TxtField03';
import Btn021 from 'dc/Btn021';
import Ico36 from 'dc/Ico36';

export const Text = styled(Typ30)`
  width: 100%;
  color: #455a64;
  margin-top: 8px;
  text-align: start;
`;

export const RadioWrapper = styled.div`
  width: 100%;
  margin: 20px 0 28px;
  padding-left: 14px;
`;

export const Radio = styled(SwiLab02)`
  margin-bottom: 12px;
  div {
    color: #90a4ae;
  }
  span {
    color: #37474f;
  }
`;

export const FeedbackInput = styled(TxtField07)`
  margin-top: 12px;
  width: 100%;
  height: 144px;
  > div {
    height: 100%;
  }
  textarea {
    width: 100%;
  }
`;

export const DeleteWrapper = styled.div`
  width: 80%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Input = styled(TxtField03)`
  width: 100%;
  margin-bottom: 22px;
`;

export const DeleteButton = styled(Btn021)`
  display: block;
  width: 100%;
  background-color: #d9464d;
`;

export const WarningWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
`;

export const BackIconWrapper = styled.div`
  padding: 0;
  position: absolute;
  width: 36px;
  height: 36px;
  left: -58px;
  background-color: #fff;
  box-shadow:
    0 1px 4px rgba(0, 0, 0, 0.12),
    0px 1px 6px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

export const BackIcon = styled(Ico36)`
  color: rgba(0, 0, 0, 0.54);
`;

export const WarningIcon = styled(Ico36)`
  color: #d9464d;
  margin-right: 12px;
`;

export const WarningText = styled(Typ31)`
  color: #d9464d;
`;
